import { useState, useEffect } from "react";
import { useTranslation } from "../contexts/TranslationContext";
import { fetchMembersContent } from "../APIClient/apiClient";

export function useMembersContent() {
  const { currentLanguage } = useTranslation();
  const [content, setContent] = useState({
    title: "",
    description: "",
    members: [],
    metaTitle: "",
  });

  useEffect(() => {
    let isActive = true;

    setContent({
      title: "",
      description: "",
      members: [],
      metaTitle: "",
    });

    fetchMembersContent(currentLanguage).then((data) => {
      if (!isActive) {
        return;
      }
      if (data) {
        setContent(data);
      }
    });

    return () => {
      isActive = false;
    };
  }, [currentLanguage]);

  return content;
}
